import CustomFetch from "components/API/customFetch";

const hasAuthToken = () =>
    typeof window !== "undefined" && Boolean(window.localStorage.getItem("tradez-token"));

const getErrorMessage = async (response) => {
    try {
        const data = await response.json();
        return data?.detail || data?.title || "Não foi possível concluir a operação.";
    } catch (error) {
        return "Não foi possível concluir a operação.";
    }
};

const sendRequest = async (url, requestOptions, { authenticated = true } = {}) => {
    const requestFn = authenticated ? CustomFetch : fetch;
    const response = await requestFn(url, requestOptions);

    if (!response.ok) {
        throw new Error(await getErrorMessage(response));
    }

    if (response.status === 204) {
        return null;
    }

    return response.json();
};

export const GetPaymentPlans = async () => {
    return sendRequest(`${process.env.REACT_APP_API}/Payment/plans`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    }, { authenticated: false });
};

export const CreatePaymentIntent = async (requestBody) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody)
    };

    return sendRequest(`${process.env.REACT_APP_API}/Payment/create-checkout-intent`, requestOptions, {
        authenticated: hasAuthToken(),
    });
};

export const ClaimLatestPayment = async () => {
    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
    };

    return sendRequest(`${process.env.REACT_APP_API}/Payment/claim-latest-payment`, requestOptions);
};

//TODO: Ver se isso aqui vai ser preciso
export const UpdateUserPaymentDetails = async () => {
    const requestOptions = {
        method: 'PUT',
        // body: JSON.stringify(requestBody)
    };

    return sendRequest(`${process.env.REACT_APP_API}/Payment/user-payment-details`, requestOptions);
};


export default CreatePaymentIntent;
